import { waitForFrameDelayBelowThreshold } from "@faire/retailer-visitor-shared/services/performance/lib";
import { delay } from "@faire/web--source/common/delay";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
export function requestIdleCallbackOrFallback(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    var requestIdleCallback = getWindowOrThrow().requestIdleCallback;
    if (requestIdleCallback) {
        requestIdleCallback(callback, {
            timeout: timeout
        });
    } else {
        Promise.race([
            delay(timeout),
            new Promise(function(resolve) {
                return waitForFrameDelayBelowThreshold(100, resolve);
            })
        ]).then(callback);
    }
}
